/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_hub_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube Thumbnail Downloader`)
};

const es_yt_hub_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargador de Miniaturas de YouTube`)
};

const de_yt_hub_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube-Thumbnail-Downloader`)
};

const nl_yt_hub_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube Thumbnail Downloader`)
};

const fr_yt_hub_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléchargeur de miniatures YouTube`)
};

const it_yt_hub_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloader Miniature YouTube`)
};

const pt_br2_yt_hub_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloader de Thumbnail do YouTube`)
};

const pt_yt_hub_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloader de Miniaturas do YouTube`)
};

const ja_yt_hub_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTubeサムネイルダウンローダー`)
};

const zh_yt_hub_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube 缩略图下载器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_hub_h1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_hub_h1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_hub_h1", locale)
	if (locale === "en") return en_yt_hub_h1(inputs)
	if (locale === "es") return es_yt_hub_h1(inputs)
	if (locale === "de") return de_yt_hub_h1(inputs)
	if (locale === "nl") return nl_yt_hub_h1(inputs)
	if (locale === "fr") return fr_yt_hub_h1(inputs)
	if (locale === "it") return it_yt_hub_h1(inputs)
	if (locale === "pt-BR") return pt_br2_yt_hub_h1(inputs)
	if (locale === "pt") return pt_yt_hub_h1(inputs)
	if (locale === "ja") return ja_yt_hub_h1(inputs)
	return zh_yt_hub_h1(inputs)
};